// extracted by mini-css-extract-plugin
module.exports = {"fullwidth":"_c1cdfbb","fullwidthVideo":"_ce722a2","fullwidthCta":"_f9e8e38"};